/**
 * Created by staffanrantzow on 12/04/16.
 */

export default class UserEntity {

  constructor (
    id,
    accountClearingNr,
    accountNr,
    apiConsumerId,
    autogen,
    bankgiro,
    cellphone,
    co,
    companyName,
    createdAt,
    defaultTaxkeyId,
    email,
    emailConfirmed,
    firstName,
    foreclosure,
    lastLogin,
    lastName,
    loyaltyPoints,
    postgiro,
    professionTitle,
    professionId,
    role,
    showRegInvoicePage,
    socialSecurityNr,
    telephone,
    userIdOwner,
    verifyPassword,
    addedlatest,
    bic,
    receiveEmailNotifications,
    iban,
    imageSrc,
    itp,
    lang,
    preferredPaymentTypeID,
    showNameInNetwork,
    displayHsd,
    receiveSmsNotifications,
    vacationPay,
    vacationPayGross,
    internationalAccount,
    canChangeItp,
    saveITP,
    itpRate,
    saveVacationPay,
    address,
    bank
  ) {
    this.id = id;

    // Attributes
    this.accountClearingNr = accountClearingNr;
    this.accountNr = accountNr;
    this.apiConsumerId = apiConsumerId;
    this.autogen = autogen;
    this.bankgiro = bankgiro;
    this.cellphone = cellphone;
    this.co = co;
    this.companyName = companyName;
    this.createdAt = createdAt;
    this.defaultTaxkeyId = defaultTaxkeyId;
    this.email = email;
    this.emailConfirmed = emailConfirmed;
    this.firstName = firstName;
    this.foreclosure = foreclosure;
    this.lastLogin = lastLogin;
    this.lastName = lastName;
    this.loyaltyPoints = loyaltyPoints;
    this.postgiro = postgiro;
    this.professionTitle = professionTitle;
    this.professionId = professionId;
    this.role = role;
    this.showRegInvoicePage = showRegInvoicePage;
    this.socialSecurityNr = socialSecurityNr;
    this.telephone = telephone;
    this.userIdOwner = userIdOwner;
    this.verifyPassword = verifyPassword;
    this.address = address;
    this.imageSrc = imageSrc;

    // Extended
    this.addedlatest = addedlatest;
    this.bic = bic !== null ? bic : '';
    this.receiveEmailNotifications = receiveEmailNotifications;
    this.iban = iban !== null ? iban : '';
    this.itp = itp;
    this.lang = lang;
    this.preferredPaymentTypeID = preferredPaymentTypeID;
    this.showNameInNetwork = showNameInNetwork;
    this.displayHsd = displayHsd;
    this.receiveSmsNotifications = receiveSmsNotifications;
    this.vacationPay = vacationPay;
    this.vacationPayGross = vacationPayGross;
    this.internationalAccount = internationalAccount !== null ? internationalAccount : 'off';
    this.canChangeItp = canChangeItp;
    this.saveITP = saveITP;
    this.itpRate = itpRate;
    this.saveVacationPay = saveVacationPay;
    this.bank = bank;

    this.calcKey = 1; // defaultTaxkeyId but we have no option yet
  }

  get fullName () {
    return this.firstName + ' ' + this.lastName;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/user/user-entity.js
 **/